import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Form, Row, Col, Select, DatePicker, Button } from 'antd';
import { styleGutterRow } from '../../common/configConstants';
import moment from 'moment';

export class FormFiltroLogRpa extends Component {
  static propTypes = {
    logsSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      drawerVisible: false,
      optionsAgendamentoRPA: [],
    };
  }

  componentWillMount() {
    const { logsSistema } = this.props;

    var optionsAgendamentoRPA = [];
    logsSistema.listaAgendamentoRPA.forEach(item => {
      optionsAgendamentoRPA.push({ id: item.id, nome: item.Nome });
      // let findOption = optionsAgendamentoRPA.find(optionAgendamentoRPA => optionAgendamentoRPA.id === item.AgendamentoRPAId);
      // if (!findOption) {
      // }
    });
    optionsAgendamentoRPA.sort((a, b) => {
      if (a.nome < b.nome) {
        return -1;
      }
      if (a.nome > b.nome) {
        return 1;
      }
      return 0;
    });
    this.setState({ optionsAgendamentoRPA });
  }
  handleSubmit = e => {
    const { form, actions } = this.props;
    e.preventDefault();

    const values = form.getFieldsValue();
    const where = this.montrarWhere(values);
    // var scopeWhere = {};
    // if (values.AgendamentoRPAId) {
    //   scopeWhere = {
    //     Nome: values.AgendamentoRPAId
    //   }
    // }

    actions.listarLogsRpa({
      where,
      order: 'DataLog desc',
      include: ['AgendamentoRPA'],
    });
  };
  montrarWhere = values => {
    let where = {};

    if (values.AgendamentoRPAId) where.AgendamentoRPAId = { inq: values.AgendamentoRPAId };

    if (values.TipoLog && values.TipoLog.length > 0) where.TipoLog = { inq: values.TipoLog };

    if (values.DataInicioLog && values.DataFimLog) {
      where.DataLog = {
        between: [
          values.DataInicioLog
            ? moment(values.DataInicioLog).startOf('day')
            : moment(new Date()).startOf('day'),
          values.DataFimLog
            ? moment(values.DataFimLog).endOf('day')
            : moment(new Date()).endOf('day'),
        ],
      };
    } else {
      if (values.DataInicioLog) {
        where.DataLog = { gte: moment(values.DataInicioLog).startOf('day') };
      }
      if (values.DataFimLog) {
        where.DataLog = { lte: moment(values.DataFimLog).endOf('day') };
      }
    }

    return where;
  };

  render() {
    const {
      form: { getFieldDecorator },
      logsSistema,
    } = this.props;
    const { optionsAgendamentoRPA } = this.state;

    return (
      <div className="logs-sistema-form-filtro-log-rpa">
        <Form onSubmit={this.handleSubmit}>
          <Row gutter={styleGutterRow}>
            <Col md={24}>
              <Row gutter={4}>
                <Col md={12}>
                  <Form.Item label="Rotina RPA" colon={false}>
                    {getFieldDecorator('AgendamentoRPAId', {})(
                      <Select mode="multiple">
                        {optionsAgendamentoRPA.map(item => {
                          return (
                            <Select.Option value={item.id} key={item.id}>
                              {item.nome}
                            </Select.Option>
                          );
                        })}
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item label="Tipo de Log" colon={false}>
                    {getFieldDecorator('TipoLog', {})(
                      <Select mode="multiple">
                        <Select.Option value={'completo'}>{`Completo`}</Select.Option>
                        <Select.Option value={'Erro'}>{`Erro`}</Select.Option>
                        <Select.Option value={'execucao'}>{`Execução`}</Select.Option>
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={4}>
                <Col md={12}>
                  <Form.Item label="Data Log" colon={false}>
                    {getFieldDecorator('DataInicioLog', {})(
                      <DatePicker format={'DD/MM/YYYY'} placeholder={'Selecione a data'} />,
                    )}
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item label=" " colon={false}>
                    {getFieldDecorator('DataFimLog', {})(
                      <DatePicker format={'DD/MM/YYYY'} placeholder={'Selecione a data'} />,
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col md={24}>
                  <Form.Item colon={false}>
                    <Button
                      htmlType="submit"
                      type="primary"
                      icon="search"
                      loading={logsSistema.listarLogsRpaPending}
                    >
                      Pesquisar
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    logsSistema: state.logsSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

FormFiltroLogRpa = Form.create({ name: 'FormFiltroLogRpa' })(FormFiltroLogRpa);

FormFiltroLogRpa = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormFiltroLogRpa);
export default FormFiltroLogRpa;



// WEBPACK FOOTER //
// ./src/features/logs-sistema/FormFiltroLogRpa.js